import { configureStore} from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import counterReducer from "../features/counter/counterSlice";
import focusReducer from "../features/focus/focusSlice";
import statisticsReducer from "../features/statistics/statisticsSlice";

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        focus: focusReducer,
        statistics: statisticsReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: false
})